import type { ReactElement, ReactNode } from 'react';
import { TONE_GLYPH, type Tone } from '../domain/labels';

export interface StatusPillProps {
  readonly tone: Tone;
  readonly children: ReactNode;
  /** Extra context read by screen readers, e.g. what the status applies to. */
  readonly srPrefix?: string;
}

/**
 * A status chip. The glyph is part of the content, not decoration: colour is
 * never the sole carrier of meaning in this panel.
 */
export function StatusPill({ tone, children, srPrefix }: StatusPillProps): ReactElement {
  return (
    <span className={`status-pill status-pill--${tone}`}>
      {srPrefix !== undefined && <span className="visually-hidden">{srPrefix}: </span>}
      <span aria-hidden="true">{TONE_GLYPH[tone]}</span>
      <span>{children}</span>
    </span>
  );
}
